(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'sv', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function img(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function load(h) {
    if (!cache[h]) cache[h] = fetch(root + 'products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.json(); });
    return cache[h];
  }
  function sizeOf(v) { return v.option1; }
  function sizeKey(s) { var m=String(s).replace(',', '.').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/); return m ? m[1]+'x'+m[2] : s; }
  function sizeLabel(s) { return window.PVSizeLabel ? window.PVSizeLabel(s) : s; }
  function targets(card) { return (card.dataset.sizes||'').split(',').filter(Boolean); }
  function available(p) { return p.variants.filter(function(v){return v.available;}); } function frameOf(v) { return v.option2 || ''; }
  function uniq(a) { var o = []; a.forEach(function (x) { if (o.indexOf(x) < 0) o.push(x); }); return o; }
  var cards = [].slice.call(document.querySelectorAll('[data-pv-bundle-card]'));
  cards.forEach(function (card) {
    var handles = card.dataset.handles.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    card._p = Promise.all(handles.map(load)).then(function (prods) {
      card._prods = prods;
      var chosen=targets(card), full=0;
      prods.forEach(function(p,i){var vs=available(p).filter(function(v){return !chosen.length||sizeKey(sizeOf(v))===chosen[i];});if(!vs.length)throw new Error('Unavailable bundle component');full+=Math.min.apply(null,vs.map(function(v){return v.price;}));});
      var pct = Number(card.dataset.pct);
      card.querySelector('[data-pv-deal]').textContent = money(Math.round(full * (100 - pct) / 100));
      card.querySelector('[data-pv-full]').textContent = pct ? money(full) : '';
      card.querySelector('[data-pv-thumbs]').style.setProperty('--bundle-count',prods.length);
      var sc = card.querySelector('[data-pv-scene]');
      if (sc) {
        var count=prods.length, layout;
        if(count===5) layout=[[45,0,50,70],[9,0,30,40],[101,0,30,40],[13.5,46,21,29.7],[105.5,46,21,29.7]];
        else if(count===6) layout=[[36,0,50,70],[92,0,50,70],[0,0,30,40],[148,0,30,40],[4.5,46,21,29.7],[152.5,46,21,29.7]];
        if(layout){
          var maxX=Math.max.apply(null,layout.map(function(a){return a[0]+a[2];}));
          var maxY=Math.max.apply(null,layout.map(function(a){return a[1]+a[3];}));
          var scale=Math.min(64/maxX,36/(maxY*1.5)), offset=(100-maxX*scale)/2;
          layout=layout.map(function(a){return [offset+(a[0]+a[2]/2)*scale,8+(a[1]+a[3]/2)*scale*1.5,a[2]*scale,a[3]*scale*1.5];});
        } else {
          var Z={concrete:[29.3,41],sofa:[26.4,38],bed:[25.9,36],hall:[32.2,42]}[sc.dataset.room]||[30,40];
          var w=Z[1]*5/7*2/3,gap=w*.2;
          layout=prods.map(function(p,i){return [50+(i-(count-1)/2)*(w+gap),Z[0],w,Z[1]];});
        }
        prods.forEach(function(p,i){
          var box=layout[i],f=document.createElement('span');f.className='pv-scene-frame';
          f.style.cssText='left:'+box[0]+'%;top:'+box[1]+'%;width:'+box[2]+'%;height:'+box[3]+'%';
          var artVariant=p.variants.find(function(v){return frameOf(v)==='No frame'&&sizeKey(sizeOf(v))==='50x70'&&v.featured_image;});
          var art=artVariant&&artVariant.featured_image;
          if(art&&art.width===2048&&art.height===2048){
            var ns='http://www.w3.org/2000/svg',svg=document.createElementNS(ns,'svg'),im=document.createElementNS(ns,'image');
            svg.setAttribute('viewBox','316 33 1418 1986');svg.setAttribute('preserveAspectRatio','xMidYMid slice');
            im.setAttribute('href',img(art.src,900));im.setAttribute('width','2048');im.setAttribute('height','2048');svg.appendChild(im);f.appendChild(svg);
          }else{var im=document.createElement('img');im.src=img(art?art.src:p.featured_image,700);im.alt='';im.loading='lazy';f.appendChild(im);}
          sc.appendChild(f);
        });
      }
      var t = card.querySelector('[data-pv-thumbs]');
      prods.forEach(function (p) {
        var a = document.createElement('a'); a.href = p.url; a.title = p.title;
        var i = document.createElement('img'); i.src = img(p.featured_image, 240); i.alt = p.title; i.loading = 'lazy';
        var s = document.createElement('span'); s.textContent = p.title;
        a.append(i, s); t.appendChild(a);
      });
      return prods;
    }).catch(function () { card.hidden = true;card._failed=true; });
  });

  /* lightbox */
  var lb = document.querySelector('[data-pv-lightbox]');
  function lbOpen(card) {
    card._p.then(function (prods) {
      if(!prods)return;
      var li = lb.querySelector('.pv-lightbox-img'); var oldScene=lb.querySelector('[data-pv-lb-scene]'); if(oldScene)oldScene.remove(); var source=card.querySelector('.pv-bundle-media'); li.hidden=!!source.querySelector('[data-pv-scene]'); if(li.hidden){var scene=document.createElement('div');scene.className='pv-bundle-media';scene.dataset.pvLbScene='';scene.style.cssText='position:relative;aspect-ratio:3/2;width:100%;overflow:hidden';Array.from(source.children).filter(function(n){return n.tagName==='IMG'||n.hasAttribute('data-pv-scene');}).forEach(function(n){scene.appendChild(n.cloneNode(true));});li.before(scene);}else{li.src=source.querySelector('img').src;} li.alt=card.dataset.name;
      var host = lb.querySelector('[data-pv-lbitems]'); host.innerHTML = '';
      prods.forEach(function (p) {
        var a = document.createElement('a'); a.href = p.url; a.className = 'pv-lb-item';
        a.innerHTML = '<img alt=""><strong></strong><span></span>';
        a.querySelector('img').src = img(p.featured_image, 700); a.querySelector('img').alt = p.title;
        a.querySelector('strong').textContent = p.title;
        a.querySelector('span').textContent = money(p.price_min) + ' →';
        host.appendChild(a);
      });
      lb.hidden = false; document.documentElement.style.overflow = 'hidden';
    });
  }
  function lbClose() { lb.hidden = true; document.documentElement.style.overflow = ''; }
  lb && lb.querySelectorAll('[data-pv-lbclose]').forEach(function (n) { n.onclick = lbClose; });

  /* drawer */
  var d = document.querySelector('[data-pv-bundle-drawer]');
  var cur = null, size = null, frame = null, lastTrigger=null;
  function pick(p,i) { return p.variants.find(function(v){return sizeOf(v)===(cur.mixed?cur.selectedSizes[i]:size)&&frameOf(v)===frame&&v.available;}); }
  function frameLabel(v){var map={'No frame':'none','White frame':'white','Wood frame':'wood','Dark wood frame':'dark','Black frame':'black'};return d.dataset[map[v]]||v;}
  function chips(host, vals, act, fn) {
    host.innerHTML = '';
    vals.forEach(function (v) { var b = document.createElement('button'); b.type = 'button'; b.textContent = host.hasAttribute('data-pv-sizes') ? sizeLabel(v) : frameLabel(v); b.setAttribute('aria-pressed', v === act); b.onclick = function () { fn(v); }; host.appendChild(b); });
  }
  function render() {
    if(!cur.mixed)chips(d.querySelector('[data-pv-sizes]'),cur.sizes,size,function(v){size=v;render();});
    var validFrames=cur.frames.filter(function(f){return cur.prods.every(function(p,i){return available(p).some(function(v){return sizeOf(v)===(cur.mixed?cur.selectedSizes[i]:size)&&frameOf(v)===f;});});});
    if(validFrames.indexOf(frame)<0)frame=validFrames[0];
    chips(d.querySelector('[data-pv-frames]'),validFrames,frame,function(v){frame=v;render();});
    var sum = 0, ok = true;
    cur.prods.forEach(function (p,i) { var v = pick(p,i); if (!v || !v.available) ok = false; else sum += v.price; });
    d.querySelector('[data-pv-total]').textContent = ok ? money(Math.round(sum * (100 - cur.pct) / 100)) : '—';
    d.querySelector('[data-pv-was]').textContent = ok && cur.pct ? money(sum) : '';
    var err=d.querySelector('[data-pv-bundle-error]');err.hidden=ok;err.textContent=ok?'':d.dataset.unavailable;
    d.querySelector('[data-pv-add]').disabled = !ok;
  }
  function dOpen(card) {
    card._p.then(function (prods) {
      if(!prods)return;
      lastTrigger=card.querySelector('.pv-bundle-open');
      var chosen=targets(card);
      cur={name:card.dataset.name,pct:Number(card.dataset.pct),prods:prods,mixed:chosen.length>0};
      cur.sizes=uniq(available(prods[0]).map(sizeOf)).filter(function(s){return available(prods[0]).some(function(first){return sizeOf(first)===s&&prods.every(function(p){return available(p).some(function(v){return sizeOf(v)===s&&frameOf(v)===frameOf(first);});});});});
      cur.frames=uniq(available(prods[0]).map(frameOf));
      cur.selectedSizes=prods.map(function(p,i){var v=available(p).find(function(v){return sizeKey(sizeOf(v))===chosen[i];});return v&&sizeOf(v);});
      size=cur.sizes[0];frame=cur.frames.includes('No frame')?'No frame':cur.frames[0];
      d.querySelector('[data-pv-common-size]').hidden=cur.mixed;
      d.querySelector('[data-pv-mixed-note]').hidden=!cur.mixed;
      d.querySelector('[data-pv-discount-note]').hidden=!cur.pct;
      d.querySelector('[data-pv-duo-note]').hidden=!!cur.pct;
      d.querySelector('[data-pv-drawer-title]').textContent = cur.name;
      var it = d.querySelector('[data-pv-drawer-items]'); it.innerHTML = '';
      prods.forEach(function(p,index){
        var item=document.createElement('div');item.className='pv-bundle-drawer-item';
        var a=document.createElement('a');a.href=p.url;var image=document.createElement('img');image.src=img(p.featured_image,180);image.alt=p.title;a.appendChild(image);
        var text=document.createElement('div'),title=document.createElement('strong');title.textContent=p.title;text.appendChild(title);
        if(cur.mixed){var label=document.createElement('span');label.textContent=sizeLabel(cur.selectedSizes[index]);text.appendChild(label);}
        item.append(a,text);it.appendChild(item);
      });
      render(); d.hidden = false; document.documentElement.style.overflow = 'hidden';d.querySelector('[data-pv-close].pv-bundle-drawer-close').focus();
    });
  }
  function dClose() {var wasOpen=!d.hidden;d.hidden=true;document.documentElement.style.overflow='';if(wasOpen)lastTrigger?.focus();}
  d.querySelectorAll('[data-pv-close]').forEach(function (n) { n.onclick = dClose; });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { dClose(); lb && lbClose(); } });
  cards.forEach(function (c) {
    c.querySelector('.pv-bundle-open').onclick = function () { dOpen(c); };
    c.querySelector('[data-pv-zoom]').onclick = function () { lbOpen(c); };
  });
  d.querySelector('[data-pv-add]').onclick = function () {
    var btn = this; if (!cur || btn.disabled) return;
    var items = cur.prods.map(function (p,i) { var v = pick(p,i); return v && { id: v.id, quantity: 1, properties: { _pv_bundle: cur.name, _pv_frame: frameOf(v), _pv_material: 'poster' } }; });
    if (items.some(function (x) { return !x; })) return;
    btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw 0; location.href = root + 'cart'; })
      .catch(function () { btn.disabled=false;var err=d.querySelector('[data-pv-bundle-error]');err.textContent=d.dataset.error;err.hidden=false; });
  };
  document.querySelectorAll('[data-pv-bundle-filter]').forEach(function(button){button.onclick=function(){
    var value=button.dataset.pvBundleFilter;button.closest('.pv-bundles').dataset.view=value;
    document.querySelectorAll('[data-pv-bundle-filter]').forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});
    cards.forEach(function(c){var n=Number(c.dataset.count);c.hidden=c._failed||!(value==='all'||value==='wall'&&n>3||String(n)===value);});
  };});
  document.addEventListener('keydown',function(e){
    var panel=!d.hidden?d:lb&&!lb.hidden?lb:null;if(e.key!=='Tab'||!panel)return;
    var controls=[...panel.querySelectorAll('button:not([disabled]),a[href]')].filter(function(el){return el.getClientRects().length;});
    var first=controls[0],last=controls[controls.length-1];if(!first)return;
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
  window.PvBundleDrawer = {
    close: dClose,
    open: function (options) {
      if (!options || !options.products || options.products.length !== 3) return;
      var prods = options.products;
      var chosen = options.sizes || [];
      var compatible = available(prods[0]).some(function (v) {
        return prods.every(function (p, i) { return available(p).some(function (other) {
          return (chosen.length ? sizeKey(sizeOf(other)) === chosen[i] : sizeOf(other) === sizeOf(v)) && frameOf(other) === frameOf(v);
        }); });
      });
      if (!compatible) return;
      var card = {
        _p: Promise.resolve(prods),
        dataset: { name: options.name, pct: String(options.pct), sizes: chosen.join(',') },
        querySelector: function () { return options.trigger || null; }
      };
      dOpen(card);
    }
  };
})();


